var styleDataHash = "3f2b1d20";
const injectCss = (() => {
  var css = `._2g1GJ{align-items:center;background:rgba(0,0,0,.5);color:#fff;display:flex;height:100%;justify-content:center;position:absolute;text-align:center;top:0;width:100%}.a40yd{height:20px;width:20px}.ErvfG{margin-bottom:56px}._1oYiO{font-size:16px;line-height:24px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var media_item_error_msg_default = {
  "error": "_2g1GJ",
  "errorIcon": "a40yd",
  "errorIconWithMessage": "ErvfG",
  "errorMsg": "_1oYiO"
};
export {
  media_item_error_msg_default as default,
  injectCss
};
//# sourceMappingURL=media-item-error-msg-scss.js.map
